import {createAction} from "typesafe-actions";
import {IBannerSass} from "./types";

export interface IModifyingActiveBannerSassActionPayload {
    bannerSass: Partial<IBannerSass>;
}

export const modifyingActiveBannerSassAction = createAction('MODIFYING_ACTIVE_BANNER_SASS', action => {
    return (params: IModifyingActiveBannerSassActionPayload) => action(params);
});
